// Each open overlay claims its own layer so a nested one always paints above its
// opener. Depths climb while any overlay is open and reset once the last closes.

export const OVERLAY_BASE_Z = 1050
export const OVERLAY_Z_STEP = 10
export const OVERLAY_MAX_DEPTH = 40

/** Popovers, dropdowns and tooltips — always above the deepest overlay. */
export const OVERLAY_FLOATING_Z = 1500
/** Full-screen blocking loaders — above overlays and their floating layers. */
export const OVERLAY_LOADING_Z = 1600

let openLayers = 0
let nextDepth = 0

export const acquireOverlayLayer = (): number => {
  openLayers++
  const depth = Math.min(nextDepth, OVERLAY_MAX_DEPTH)
  nextDepth++
  return OVERLAY_BASE_Z + depth * OVERLAY_Z_STEP
}

export const releaseOverlayLayer = (): void => {
  openLayers = Math.max(0, openLayers - 1)
  if (openLayers === 0) {
    nextDepth = 0
  }
}

export const resetOverlayLayers = (): void => {
  openLayers = 0
  nextDepth = 0
}
